import React from 'react';
import { deepCopy } from '@lhb/func';
import Login from '@/login';
import { getTokenMerge } from '@/utils/ways';
import LocationSrounding from '@/views/ppt/pages/index/entry';
// import { message } from 'antd';

let locationFrom: any = {
  pathname: null,
  search: null,
};
// 路由守卫
function routerAfterEach(from: any, to: any, routeList: any[]) {
  // 在这里进行大数据埋点
  // console.log('form:', from);
  // console.log('to:', to);
  // console.log('routeList:', routeList);
  const title = routeList.find((item) => {
    return item.path === to.pathname;
  })?.meta?.title;
  if (!title) {
    if (to.pathname !== '/') {
      process.env.NODE_ENV === 'development' && window.microMessage.error('为了方便数据采集，请添加title！');
    }
  } else {
    window.document.title = `pms-${title}`; // 项目名-具体页面名
  }
  if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
    // 先发送离开页面的信息 再上传进入页面的信息
    window.LHBbigdata.spa.beforeRouteLeave()(to, from);
    window.LHBbigdata.spa.beforeRouteEnter()(to, from);
  }
}

const RouterControl: React.FC<{
  locationTo: any,
  routeList: Array<Record<string, any>>
}> = ({ children, locationTo, routeList }) => {
  const token = getTokenMerge(); ;
  if (locationTo.pathname !== locationFrom.pathname || locationTo.search !== locationFrom.search) {
    const { pathname } = locationTo;
    const targetRoute = routeList.find(routeItem => routeItem.path === pathname);
    if (targetRoute) {
      const { meta } = targetRoute;
      const { title } = meta || {};
      document.title = title || '资源微服务管理';
    }
    // fullPath完全改变才会触发
    routerAfterEach({
      ...locationFrom,
      fullPath: locationFrom.pathname ? locationFrom.pathname + locationFrom.search : '/',
      path: locationFrom.pathname || '/',
    }, {
      ...locationTo,
      fullPath: locationTo.pathname + locationTo.search,
      path: locationTo.pathname,
    }, routeList);
  }
  // 提前备份location数据
  const location = {
    to: locationTo,
    from: locationFrom,
  };
  locationFrom = deepCopy(locationTo);

  if (locationTo.pathname === '/ppt') return <LocationSrounding/>;

  return (
    <>
      {
        token
          ? React.Children.map(children, (child) => {
            return React.cloneElement(child as React.ReactElement, {
              location,
            });
          })
          : <Login/>
      }
    </>
  );
};

export default RouterControl;
